// @flow

import {
  GeneralModule,
  InsuranceModule,
  SeatingModule,
  PostFormAction,
  ModalOpenAction,
  GetDataAction,
  ContactDetailsModule,
  ThankyouModule,
  PrimaryEmailDetail,
  SpecialAssistanceModule,
  SportsEquipmentsModule,
  MusicalInstrumentsModule,
  PetPassengersModule,
  ItineraryChangeModule,
  BaggageModule,
  SelectPassengerBaggageAction,
} from "mmb/services/tracking/constants/trackingEvents"
import type {
  TrackingModule,
  TrackingAction,
} from "mmb/services/tracking/constants/trackingEventTypes"
import { ACTIONS as BOOKING_ACTIONS } from "mmb/consts/booking"
import {
  LOAD_SEATS,
  SET_MODAL_OPEN,
} from "mmb/scenes/AccountBooking/components/Booking/services/consts"
import { SUBMIT_SEATS } from "mmb/scenes/AccountBooking/components/Booking/services/additionalServices/consts"
import { SUBMIT as INSURANCE_SUBMIT } from "mmb/scenes/AccountBooking/components/Booking/services/bookingInsurance/consts"
import { SPECIAL_ASSISTANCE_SUBMIT } from "mmb/scenes/AccountBooking/components/Booking/scenes/BookingAdditionalServices/scenes/SpecialAssistance/consts/actions"
import { SPORTS_EQUIPMENT_SUBMIT } from "mmb/scenes/AccountBooking/components/Booking/scenes/BookingAdditionalServices/scenes/SportsEquipment/consts/actions"
import { MUSICAL_EQUIPMENT_SUBMIT } from "mmb/scenes/AccountBooking/components/Booking/scenes/BookingAdditionalServices/scenes/MusicalEquipment/consts/actions"
import { PETS_SUBMIT } from "mmb/scenes/AccountBooking/components/Booking/scenes/BookingAdditionalServices/scenes/Pets/consts/actions"
import { CONFIRM as ITINERARY_CHANGE_SUBMIT } from "mmb/scenes/AccountBooking/components/Booking/services/changeFlights/consts"
import { SELECT_PASSENGER_BAGGAGE } from "mmb/scenes/AccountBooking/components/Booking/scenes/BookingAddBags/services/constants"

export const ActionTypeToEventDictionary: {
  [string]: { module: TrackingModule, action: TrackingAction, detail?: string },
} = {
  [INSURANCE_SUBMIT]: { module: InsuranceModule, action: PostFormAction },
  [SET_MODAL_OPEN]: { module: GeneralModule, action: ModalOpenAction },
  [SUBMIT_SEATS]: { module: SeatingModule, action: PostFormAction },
  [LOAD_SEATS]: { module: SeatingModule, action: GetDataAction },
  [BOOKING_ACTIONS.CHANGE_PRIMARY_EMAIL]: {
    module: ThankyouModule,
    action: PostFormAction,
    detail: PrimaryEmailDetail,
  },
  [BOOKING_ACTIONS.ADDITIONAL_CONTACTS]: {
    module: ContactDetailsModule,
    action: PostFormAction,
  },
  [SPECIAL_ASSISTANCE_SUBMIT]: { module: SpecialAssistanceModule, action: PostFormAction },
  [SPORTS_EQUIPMENT_SUBMIT]: { module: SportsEquipmentsModule, action: PostFormAction },
  [MUSICAL_EQUIPMENT_SUBMIT]: { module: MusicalInstrumentsModule, action: PostFormAction },
  [PETS_SUBMIT]: { module: PetPassengersModule, action: PostFormAction },
  [ITINERARY_CHANGE_SUBMIT]: { module: ItineraryChangeModule, action: PostFormAction },
  [SELECT_PASSENGER_BAGGAGE]: {
    module: BaggageModule,
    action: SelectPassengerBaggageAction,
  },
}

export type TrackedEventTypes = $Keys<typeof ActionTypeToEventDictionary>

export const getTrackingEventFromAction = (action: {
  type: TrackedEventTypes | string,
  original_type: string,
  _track?: { value?: any, event: string },
  action?: any,
  res?: any,
}): ?{ module: TrackingModule, action: TrackingAction, detail?: string } => {
  if (ActionTypeToEventDictionary[action.type]) {
    return ActionTypeToEventDictionary[action.type]
  }

  if (ActionTypeToEventDictionary[action.original_type]) {
    return ActionTypeToEventDictionary[action.original_type]
  }

  if (action.action && ActionTypeToEventDictionary[action.action]) {
    return ActionTypeToEventDictionary[action.action]
  }

  return null
}
